import React from "react";
import styles from "./SmallDropdownContent.module.css";

export const SmallDropdownContent = (props) => {
    return (
        <div className={props.open ? styles.contentOpen : styles.contentClosed}>
            {props.open ? props.content : null}
        </div>
    );
}